// Module
var code = `<div class="modal fade" id="addNewCustomerModal" tabindex="-1" role="dialog" data-bind="showModal: show">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" data-bind="click: clear">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title" data-bind="label: 'cc_P_ADDRESS_CUSTOMER_LIST'"></h4>
            </div>
            <div class="modal-body">
                
                <div class="list-group">
                    <table class="table table-hover table-striped table-sortable">
                        <thead>
                            <tr>
                                <th data-bind="label: 'cc_P_CUSTOMER_NAME'" style="white-space: nowrap;"></th>
                                <th data-bind="label: 'CAddress'" style="white-space: nowrap;"></th>
                                <th data-bind="label: 'cc_P_CUSTOMER_ZIP'" style="white-space: nowrap;"></th>
                                <th data-bind="label: 'cc_P_CUSTOMER_DISTANCE'" style="white-space: nowrap;"></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: customers">
                            <tr data-bind="click: \$component.changeSelectedCustomer" style="cursor: pointer">
                                <td data-bind="text: cf1"></td>
                                <td data-bind="text: cf2"></td>
                                <td data-bind="text: cf3"></td>
                                <td data-bind="text: cf4"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" data-dismiss="modal" data-bind="click: clear, label: 'cc_Close'"></button>
                <button type="button" class="btn btn-primary pull-left" data-dismiss="modal" data-bind="click: createNewCustomer, label: 'cc_P_NEW_RECORD'"></button>
            </div>
        </div>
    </div>
</div>`;
// Exports
module.exports = code;